import * as types from '../../mutation-types'
import * as api from '../../api'

const state = {
  status_messages: []
}

const getters = {
  g2_ip_speaker_status_messages: state => state.status_messages
}

const actions = {
  G2IPSpeakerAutoReboot ({ commit }, { ip_start, ip_end, tftp_server }) {
    return api.instance.post('g2ipspeaker_auto_reboot', {
      ip_start: ip_start,
      ip_end: ip_end,
      tftp_server: tftp_server
    })
    .then(function (response) {
      commit(types.G2IP_SPEAKER_AUTO_REBOOT_STATUS_MESSAGES, response.data['messages'])
    })
    .catch(function () {
      console.log('error')
    })
  },
}

const mutations = {
  [types.G2IP_SPEAKER_AUTO_REBOOT_STATUS_MESSAGES] (state, status_messages) {
    state.status_messages = status_messages
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
